import { BaseApiClient } from '@/Services/ApiClients/BaseApiClient';
import { UserContract } from '@/Models/Contracts/UserContract';

export class AuthApiClient extends BaseApiClient {
    async getAuthUser() {
        return await this._axios.get<UserContract>('/auth/user');
    }
}
